module.exports = __webpack_public_path__ + "static/media/15UN-Habitat9.f3ac2984.jpg";